import builder from '../builder';
import LaundryMachine2 from '../../streamline-icons/bold/laundry-machine-2.svg';

export default builder('IconLaundryMachine2Bold', LaundryMachine2);
